import React, { ReactNode } from 'react';

export interface TabPanelProps {
  children?: ReactNode;
  index: number;
  value: number;
  keepMounted?: boolean;
}

export const tabProps = (index: number) => {
  return {
    id: `tab-${index}`,
    'aria-controls': `tabpanel-${index}`
  };
};

export const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, keepMounted, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`tabpanel-${index}`} aria-labelledby={`tab-${index}`} {...other}>
      {(value === index || keepMounted) && <>{children}</>}
    </div>
  );
};
